import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectTreatmentTable(state),
        type: 'treatment',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryTreatment,
    changeFilter: action.changeFilterTreatment,
    toggleSort: action.toggleSortTreatment,
    toggleMultiSort: action.toggleMultiSortTreatment,
    gotoPage: action.gotoPageTreatment,
    initialColumnsVisibility: action.initialTableSettingsTreatment,
    toggleColumnVisibility: action.toggleColumnVisibilityTreatment,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/TreatmentSalesOrderSearchContainer.js